module.exports = __webpack_public_path__ + "static/media/logo_Alipay.06d6e626.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/logo_Alipay.png
// module id = 142
// module chunks = 4